"use client";

import React from "react";

function ANU_h1({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <h1 className={"text-4xl mb-2.5 " + className}>{children}</h1>;
}

export { ANU_h1 };
